import React from "react";
import * as Animate from "react-reveal";
import UtivaLogo from "../../../assets/images/svg/logo/utivacolored.svg";
import LsmtLogo from "../../../assets/images/png/mba/university-partners/lsmt-logo.webp";
import StrideLogo from "../../../assets/images/png/mba/university-partners/stride-university.webp";
import EimtLogo from "../../../assets/images/png/mba/university-partners/eimt-logo.webp";
import EuroInstituteLogo from "../../../assets/images/png/mba/university-partners/euro-institute.webp";
import BirchwoodLogo from "../../../assets/images/png/mba/university-partners/birchwood-university.webp";

const universities = [
  { number: "01", name: "LSMT", logo: LsmtLogo },
  { number: "02", name: "Stride University", logo: StrideLogo },
  { number: "03", name: "EIMT", logo: EimtLogo },
  { number: "04", name: "Euro Institute", logo: EuroInstituteLogo },
  { number: "05", name: "Birchwood University", logo: BirchwoodLogo },
];

const benefits = [
  "International university access",
  "European learning exposure",
  "Cross-border perspectives",
  "Utiva Global MBA Certificate",
];

const MBAPartnersSection = () => {
  return (
    <section
      className="bg-primary text-white py-16 md:py-24 lg:py-28 px-4"
      id="partners"
    >
      <div className="container mx-auto grid grid-cols-1 lg:grid-cols-mba-partners gap-12 lg:gap-20 items-center">
        <Animate.Fade bottom>
          <div>
            <p className="flex items-center gap-3 font-poppins text-secondary text-sm font-extrabold tracking-widest uppercase mb-5">
              <span className="w-8 h-0.5 bg-secondary inline-block flex-shrink-0"></span>
              University partners
            </p>
            <h2 className="font-poppins text-white font-bold tracking-tight text-3xl md:text-4xl lg:text-5xl leading-tight max-w-lg mb-5">
              Utiva + 5 Global Universities
            </h2>
            <p className="font-poppins text-blue-100 text-sm leading-loose max-w-lg mb-7">
              Earn the Utiva Global MBA Certificate and gain access to learning
              experiences connected to five international university partners,
              including universities in Europe. The network brings cross-border
              perspectives into one practical business program.
            </p>
            <div
              className="flex flex-wrap gap-2"
              aria-label="Partnership benefits"
            >
              {benefits.map((benefit) => (
                <span
                  key={benefit}
                  className="text-white bg-white/10 border border-white/25 rounded-full px-3.5 py-2.5 font-poppins text-sm font-semibold"
                >
                  {benefit}
                </span>
              ))}
            </div>
          </div>
        </Animate.Fade>

        <Animate.Fade bottom>
          <div
            className="grid grid-cols-1 sm:grid-cols-mba-partner-network gap-4 items-stretch"
            aria-label="Utiva and five global university partners"
          >
            <article className="bg-secondary text-primary rounded-3xl min-h-[220px] sm:min-h-[422px] flex flex-col justify-end p-7 shadow-2xl">
              <img src={UtivaLogo} alt="Utiva" className="w-24 mb-auto" />
              <strong className="font-poppins tracking-tight text-2xl">
                Global MBA
              </strong>
              <small className="font-poppins uppercase tracking-wide text-xs font-bold mt-1.5">
                Lead learning partner
              </small>
            </article>

            <span
              className="w-10 h-10 rounded-full bg-white/15 text-secondary grid place-items-center text-lg self-center mx-auto"
              aria-hidden="true"
            >
              ＋
            </span>

            <div className="grid gap-2">
              {universities.map((uni) => (
                <article
                  key={uni.number}
                  aria-label={`${uni.name} university partner`}
                  className="bg-white rounded-2xl border border-white/30 grid grid-cols-mba-list-28 items-center gap-3 min-h-[78px] px-4 py-3"
                >
                  <span className="font-poppins text-primary font-extrabold text-sm">
                    {uni.number}
                  </span>
                  <img
                    src={uni.logo}
                    alt={`${uni.name} logo`}
                    className="object-contain object-left max-w-[235px] max-h-[54px]"
                  />
                </article>
              ))}
            </div>
          </div>
        </Animate.Fade>
      </div>
    </section>
  );
};

export default MBAPartnersSection;
